import { useQuery } from "@apollo/client";
import { GET_IT_APPLICATION_NAME } from "./queries";

type GetItApplicationNameData = {
  findItApplication: {
    application: string;
  };
};

type GetItApplicationNameVars = {
  applicationUUID: string;
};

export const useItApplicationName = (applicationUUID: string) => {
  const { data } = useQuery<GetItApplicationNameData, GetItApplicationNameVars>(GET_IT_APPLICATION_NAME, {
    variables: {
      applicationUUID,
    },
  });

  return data?.findItApplication?.application;
};